import { RemoteReportRadino } from 'data/usecases';
import { ReportRadinoUseCaseInterface } from 'domain/usecases';
import { makeApiUrlReportRadino } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteReportRadino = (): ReportRadinoUseCaseInterface =>
  new RemoteReportRadino(makeApiUrlReportRadino(), makeAxiosHttpClient());
